import React, { Component } from 'react'
import { connect } from 'react-redux'
import map from 'lodash/map'

import api from '../../api'
import { setSnackbarMessage } from '../../actions/snackbar'

import { CardTitle } from 'material-ui/Card'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentRemove from 'material-ui/svg-icons/content/remove'
import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import CircularProgress from 'material-ui/CircularProgress'
import Dialog from 'material-ui/Dialog'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'

const styles = {
  button: {
    margin: '1em 1em 0 0'
  },
  title: {
    paddingLeft: 0
  },
  newRedirectForm: {
    maxWidth: '500px',
    marginBottom: '20px'
  },
  inlineInput: {
    marginLeft: '10px'
  },
  newRedirectInput: {
    width: 'calc(35% - 10px)',
    marginRight: '10px'
  },
  addNewButton: {
    width: '30%'
  },
  table: {
    maxWidth: '1000px'
  }
}

class RedirectConfig extends Component<any, any> {
  state = {
    loading: true,
    submitting: false,
    submitError: false,
    newRedirect: {
      from: '',
      to: ''
    }
  }

  componentDidMount () {
    api.get('admin/settings/redirects')
      .then((res) => res.json())
      .then(({ value: redirects }) => {
        this.setState({ loading: false, redirects })
      })
  }

  createNewRedirect = () => {
    this.setState({
      redirects: {
// @ts-ignore
        ...this.state.redirects,
        [this.state.newRedirect.from.toLowerCase()]: this.state.newRedirect.to
      },
      newRedirect: {
        from: '',
        to: ''
      }
    })
  }

  handleSave = () => {
    this.setState({ submitting: true })
    api.patch('admin/settings/redirects', {
// @ts-ignore
      body: { value: this.state.redirects }
    })
      .then(res => {
        this.setState({ submitting: false })
        if (res.ok) {
          this.props.onSnackbarMessage('Save successful')
        } else {
          this.setState({ submitError: true })
        }
      })
  }

  dismissError = () => {
    this.setState({ submitError: false })
  }

  render () {
// @ts-ignore
    const { loading, redirects } = this.state

    if (loading) return null

    return (
      <div>
        <CardTitle title='Redirect Configuration' style={styles.title} />

        <form
          onSubmit={e => {
            e.preventDefault()
            this.createNewRedirect()
          }}
          style={styles.newRedirectForm}
        >
          <TextField
            hintText='From'
            value={this.state.newRedirect.from}
            onChange={(e, newValue) => this.setState({
              newRedirect: {
                ...this.state.newRedirect,
                from: newValue
              }
            })}
            style={styles.newRedirectInput}
          />
          <TextField
            style={styles.newRedirectInput}
            hintText='To'
            value={this.state.newRedirect.to}
            onChange={(e, newValue) => this.setState({
              newRedirect: {
                ...this.state.newRedirect,
                to: newValue
              }
            })}
          />
          <RaisedButton
            label='+ Add New'
            primary
            style={styles.addNewButton}
            type='submit'
            disabled={!this.state.newRedirect.to || !this.state.newRedirect.from}
          />
        </form>
        {Object.keys(redirects).length > 0 && (
          <Table
            style={styles.table}
            selectable={false}
          >
            <TableHeader
              displaySelectAll={false}
              adjustForCheckbox={false}
            >
              <TableRow>
                <TableHeaderColumn>
                  From
                </TableHeaderColumn>
                <TableHeaderColumn>
                  To
                </TableHeaderColumn>
                <TableHeaderColumn>
                  Remove
                </TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              displayRowCheckbox={false}
            >
              {map(redirects, (to, from) => (
                <TableRow key={from}>
                  <TableRowColumn>
                    {from}
                  </TableRowColumn>
                  <TableRowColumn>
                    <TextField
                      style={styles.inlineInput}
                      name='to'
                      value={to}
                      onChange={(e, newValue) => this.setState({
                        redirects: {
// @ts-ignore
                          ...this.state.redirects,
                          [from]: newValue
                        }
                      })}
                    />
                  </TableRowColumn>
                  <TableRowColumn>
                    <FloatingActionButton
                      mini
                      secondary
                      onClick={() => {
// @ts-ignore
                        const { redirects } = this.state
// @ts-ignore
                        delete this.state.redirects[from]
                        this.setState({ redirects })
                      }}
                    >
                      <ContentRemove />
                    </FloatingActionButton>
                  </TableRowColumn>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
        <RaisedButton
          label='Save'
          primary
          onClick={this.handleSave}
          style={styles.button}
          labelPosition='before'
          icon={this.state.submitting ? <CircularProgress size={20} thickness={2} /> : null}
          disabled={this.state.submitting}
        />
        <Dialog
          title='Error'
          modal
          open={this.state.submitError}
          actions={[
            <FlatButton
              label='OK'
              primary
              onClick={this.dismissError}
            />
          ]}
          onRequestClose={this.dismissError}
        >
          Unable to save redirect configuration. Ensure that every redirect "To" field is populated.
        </Dialog>
      </div>
    )
  }
}

export default connect(
  null,
  dispatch => ({
    onSnackbarMessage: (msg) => {
      dispatch(setSnackbarMessage(msg))
    }
  })
// @ts-ignore
)(RedirectConfig)
